import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { CompartmentListInitialState, CompartmentListLoad } from './compartment-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { CompartmentListService } from './compartment-list.service';
import { CompartmentBrief } from '../models';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type CompartmentListStateModel = ListServerPaginationStateModel<CompartmentBrief>;

const initialState: CompartmentListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<CompartmentListStateModel>({
  name: 'compartmentList',
  defaults: initialState,
})
@Injectable()
export class CompartmentListState {
  constructor(
    private compartmentListService: CompartmentListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: CompartmentListStateModel): CompartmentListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: CompartmentListStateModel): boolean {
    return state.loaded;
  }

  @Action(CompartmentListLoad)
  getCompartments(
    ctx: StateContext<CompartmentListStateModel>,
    { payload }: CompartmentListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.compartmentListService.getCompartmentList(payload).pipe(
      take(1),
      map((list: CompartmentBrief[]) => {
        ctx.patchState({ ...list, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(CompartmentListInitialState)
  setInitialState(ctx: StateContext<CompartmentListStateModel>): void {
    ctx.setState(initialState);
  }
}
